module.exports = __webpack_public_path__ + "static/media/Sandslash_gaussian2.7f045018.png";